import React from "react";

function Spinner({ size = 14, color = "#fff" }) {
  return (
    <>
      <style>{`
        @keyframes global-ui-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <span style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${color}33`,
        borderTopColor: color,
        animation: "global-ui-spin 0.75s linear infinite",
        flexShrink: 0,
      }} />
    </>
  );
}

export default Spinner;
